export default __webpack_public_path__ + "static/media/img_4.37a63de7.jpg";